import app from './js/app';
import './sass/main.scss';

app();
